import InnerComponent from '@Components/Logistics/GateDocument/GateDocumentForm';
import orgContainer from '@Components/AppContainer';

const CreateGateDocument = () => ((orgContainer(InnerComponent)));
export default CreateGateDocument;
